(function () {
  const choices = {
    beginning: { primary: 'NLT', alternate: 'NIV', href: '/collections/nlt', reason: 'Start with clear, natural English that lets you keep reading without stopping to untangle the sentence structure.', note: 'Choose NLT for the smoothest start; choose NIV if you want a little more of the wording you may hear at church.' },
    everyday: { primary: 'NIV', alternate: 'CSB', href: '/collections/niv', reason: 'Both aim for a useful middle ground: accurate enough for study, natural enough for steady daily reading.', note: 'NIV is the familiar all-around choice. CSB leans slightly more formal while still reading smoothly.' },
    study: { primary: 'ESV', alternate: 'NASB', href: '/collections/esv', reason: 'These translations preserve more of the original wording and sentence structure, which helps when tracing repeated words and arguments.', note: 'ESV is the more literary option; NASB is the more technical option. Many readers pair either one with NIV or NLT.' },
    traditional: { primary: 'NKJV', alternate: 'KJV', href: '/collections/nkjv', reason: 'Both carry the cadence of the King James tradition. NKJV updates older vocabulary; KJV preserves the historic wording.', note: 'Choose NKJV if you want tradition without as much archaic English. Choose KJV if its classic language is part of what you value.' },
    catholic: { primary: 'NRSV-CE', alternate: 'NABRE', href: '/collections/nrsv', reason: 'Start by choosing a Catholic edition that includes the deuterocanonical books, then compare the translation style you prefer.', note: 'Shepherd’s Shelf carries NRSV Catholic editions. NABRE is another approved choice widely used by U.S. Catholics.' }
  };

  function initializeGuide() {
    document.querySelectorAll('[data-bible-translation-guide]').forEach(function (guide) {
      const buttons = guide.querySelectorAll('[data-goal]');
      const primary = guide.querySelector('[data-result-primary]');
      const alternate = guide.querySelector('[data-result-alternate]');
      const reason = guide.querySelector('[data-result-reason]');
      const note = guide.querySelector('[data-result-note]');
      const link = guide.querySelector('[data-result-link]');
      const linkName = guide.querySelector('[data-result-link-name]');
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          const choice = choices[button.dataset.goal];
          if (!choice) return;
          buttons.forEach(function (item) {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          primary.textContent = choice.primary;
          alternate.textContent = choice.alternate;
          reason.textContent = choice.reason;
          note.textContent = choice.note;
          link.href = choice.href;
          linkName.textContent = choice.primary;
        });
      });
    });
    document.querySelectorAll('.page-loader').forEach(function (loader) { loader.style.display = 'none'; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeGuide);
  else initializeGuide();
})();
